import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { types as sdkTypes } from '../../../../util/sdkLoader';
import { useLocation } from 'react-router-dom';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';

import css from './TopbarDesktop.module.css';
import { useConfiguration } from '../../../../context/configurationContext';
import {
  groupListingFieldConfigs,
  pickListingFieldFilters,
} from '../../../SearchPage/SearchPage.shared';
import moment from 'moment';
import LandingSearchForm from '../../../../components/LandingSearchForm/LandingSearchForm';
import { formatDateRangeForTimezone } from '../../../../util/genericHelpers';

const { LatLng, LatLngBounds } = sdkTypes;
function RenderSearchPageSectionHero(props) {
  const { isTopbarSearch, showTopbarSearch } = props;
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const { listingFields } = config?.listing || {};
  const categoryConfiguration = config.categoryConfiguration;
  const activeListingTypes = config?.listing?.listingTypes.map(config => config.listingType);
  const listingFieldsConfig = pickListingFieldFilters({
    listingFields,
    locationSearch: location.search || null,
    categoryConfiguration,
  });
  const [customPrimaryFilters] = groupListingFieldConfigs(listingFieldsConfig, activeListingTypes);
  const purposeOptions =
    [
      ...customPrimaryFilters[0]?.enumOptions.slice(0, 2),
      { value: 'multipurpose', label: 'Multi Purpose' },
    ] || [];

  const handleSubmit = values => {
    const { keywords = null, location = null, dates, activities = null } = values || {};

    const searchQuery = {};
    if (keywords) searchQuery.keywords = keywords;

    const { search = 'United States', selectedPlace } = location || {};
    const defaultBounds = new LatLngBounds(
      new LatLng(62.198642531, -81.98187937),
      new LatLng(12.40936803, -125.48773874)
    );
    const { bounds = defaultBounds } = selectedPlace || {};
    Object.assign(searchQuery, { address: search, bounds });

    if (dates?.startDate) {
      const start = dates.startDate;
      const end = dates.endDate;
      // Pass both into your formatter:
      const dateRange = formatDateRangeForTimezone({
        startDate: start,
        endDate: end,
      });

      if (dateRange) {
        searchQuery.dates = dateRange;
      }
    }

    if (activities) {
      let activityArray = Array.isArray(activities) ? [...activities] : [activities];

      if (activityArray.includes('multipurpose')) {
        activityArray = activityArray
          .filter(a => a !== 'multipurpose')
          .concat('activities_photography', 'activities_videography');
        searchQuery.pub_activities = `has_all:${[...new Set(activityArray)].join(',')}`;
      } else {
        searchQuery.pub_activities = `has_any:${[...new Set(activityArray)].join(',')}`;
      }
    }

    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchQuery));
  };

  return (
    <LandingSearchForm
      rootClassName={css.landingSearchForm}
      purposeOptions={purposeOptions}
      onSubmit={handleSubmit}
      isTopbarSearch={isTopbarSearch}
      showTopbarSearch={showTopbarSearch}
    />
  );
}

export default RenderSearchPageSectionHero;
